import axios from 'axios';
import apiConfig from '../../api.config';

export default function autoCreatePaperlessUser(hotelId) {
  const {
    host,
    URIs: { autoCreatePaperlessUser },
  } = apiConfig;

  const data = {
    hotelId,
  };

  const uri = `${host}${autoCreatePaperlessUser}`;

  return axios.post(uri, data).then(res => res.data);
}
